import { render, staticRenderFns } from "./Itemview2.vue?vue&type=template&id=4e96d65a&"
import script from "./Itemview2.vue?vue&type=script&lang=js&"
export * from "./Itemview2.vue?vue&type=script&lang=js&"
import style0 from "./Itemview2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports